import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from './firebase';
import { RestaurantProvider, useRestaurant } from './context/RestaurantContext';

// Tus Componentes
import Dashboard from './components/Dashboard';
import History from './components/History';
import Header from './components/Header';
import NewOrder from './components/NewOrder';
import LoginPage from './components/LoginPage';
import RestaurantSelectorPage from './components/RestaurantSelectorPage';

// Notificaciones
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// --- ESTE ES EL COMPONENTE CORREGIDO Y SIMPLIFICADO ---
// Decide qué mostrar después de que un usuario inicie sesión.
const MainLayout = ({ user }) => {
  const { selectedRestaurant, setSelectedRestaurant } = useRestaurant();

  // Caso 1: Usuario con un solo restaurante
  if (user.restaurants?.length === 1) {
    // Si aún no se ha establecido el restaurante, lo hacemos ahora
    if (!selectedRestaurant) {
      setSelectedRestaurant(user.restaurants[0].id);
      return <div style={{textAlign: 'center', marginTop: '5rem'}}>Asignando restaurante...</div>;
    }
    // Una vez asignado, muestra el contenido (Dashboard, Historial, etc.)
    return <Outlet />;
  }
  
  // Caso 2: Usuario "Admin" con varios restaurantes
  if (user.restaurants?.length > 1) {
    // Si ya ha seleccionado uno, muestra el contenido. Si no, lo manda a la pantalla de selección.
    return selectedRestaurant ? <Outlet /> : <Navigate to="/seleccionar-restaurante" />;
  }

  // Caso de error: el usuario no tiene restaurantes asignados en la base de datos
  return <div style={{textAlign: 'center', marginTop: '5rem'}}>Error: Tu usuario no tiene ningún restaurante asignado.</div>;
};


function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        const loginDate = localStorage.getItem('loginDate');
        const todayDate = new Date().toISOString().split('T')[0];
        if (loginDate !== todayDate) {
          await signOut(auth);
          setUser(null);
        } else {
          try {
            const userDocRef = doc(db, "users", currentUser.uid);
            const userDoc = await getDoc(userDocRef);

            if (userDoc.exists()) {
              const userData = userDoc.data();
              userData.restaurants = [];

              if (userData.restaurantRef) {
                const restaurantSnap = await getDoc(userData.restaurantRef);
                if (restaurantSnap.exists()) userData.restaurants.push(restaurantSnap.data());
              } else if (userData.accessibleRestaurantRefs) {
                const restaurantPromises = userData.accessibleRestaurantRefs.map(ref => getDoc(ref));
                const restaurantSnaps = await Promise.all(restaurantPromises);
                userData.restaurants = restaurantSnaps.filter(snap => snap.exists()).map(snap => snap.data());
              }
              
              setUser({ ...currentUser, ...userData });
            } else {
              console.error("Error: Usuario autenticado pero sin perfil en Firestore.");
              await signOut(auth);
              setUser(null);
            }
          } catch (error) {
              console.error("Error al obtener el perfil del usuario:", error);
              await signOut(auth);
              setUser(null);
          }
        }
      } else {
        setUser(null);
      }
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  if (loading) {
    return <div style={{textAlign: 'center', marginTop: '5rem', fontSize: '1.2rem'}}>Cargando...</div>;
  }

  return (
    <Router>
      <RestaurantProvider>
        {user && <Header user={user} />}
        <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
        <main>
          <Routes>
            <Route path="/login" element={!user ? <LoginPage /> : <Navigate to="/" />} />
            
            <Route path="/" element={user ? <MainLayout user={user} /> : <Navigate to="/login" />}>
              <Route index element={<Dashboard />} />
              <Route path="historial" element={<History />} />
              <Route path="nueva-orden" element={<NewOrder />} />
            </Route>
            
            <Route 
              path="/seleccionar-restaurante" 
              element={user ? <RestaurantSelectorPage user={user} /> : <Navigate to="/login" />} 
            />
            
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </main>
      </RestaurantProvider>
    </Router>
  );
}

export default App;